import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import InvoiceDetails from '../detail';
import CreateInvoiceDialog from './DialogView';
import history from '../../../../utils/history';
import * as appConfig from '../../../../config';
import { LEDGERS, VAT_PERCENTAGE } from '../../../../data/enums/enums';
import * as httpUtils from '../../../../utils/httpUtils';
import * as filterUtil from '../../../../utils/filterUtil';
import TableHeader from '../../../../components/TableHeader';
import { clone, compareList } from '../../../../utils/arrayProcessor';
import { SERVICE_INVOICE_DETAILS, SERVICE_INVOICE_BASE } from '../../../../data/enums/Route';
import { fixedFloat, fixedFloatAndCommas } from '../../../../utils/conversion';
import {
  Button,
  Cell,
  Checkbox,
  Fab,
  FormField,
  Grid,
  Icon,
  LinearProgress,
  Snackbar,
} from '../../../../components/BillingMDC';
import BillingSelect from '../../../../components/Select/BillingSelect';
import BillingTextField from '../../../../components/TextField/BillingTextField';
import RadioButtonList from '../../../../components/RadioButtonList/RadioButtonList';
import {
  agentApi,
  buApi,
  catalogsApi,
  checkIfApiCallSuccess,
  ledgerApi,
  salesInvoiceApi,
  promotionApi,
} from '../../../common/base.api';
import { getDiscountedValue, handleBatchSelect } from '../../../../utils/handlers';
import {
  createServiceInvoiceConfig,
  CreateServiceInvoiceTableBody,
  customerType,
  discountOptions,
  message,
  pageValidateFieldTypes,
} from './config';
import { voucherEncoder } from '../../../../utils/miscellaneous';
import DiscountBarStyled from '../../../common/create/DiscountBarStyled';
import { has } from '../../../../utils/hasOwnProperty';
import { checkBUId, getIntegratedBUList } from '../../../common/common';
import { JWT } from '../../../../environment';
import { calculateRelativeDiscount, updateDiscountValueOfInvoiceList } from '../../common/helpers';
import ServiceInvoiceStyled from '../ServiceInvoiceStyled';
import {getBusinessId} from "../../../../utils/handlers";

class CreateInvoice extends Component {
  // return net value based upon parameters passed
  // promotionList specifies all the promotion for given sku
  // promotionByCriteria specifies the promotion for given criteria.
  // handle when invoice item number changes or updates.
  handleInvoiceItemUpdate = () => {
    // set the invoice total
    const { invoiceList } = this.state;
    // update the sales summary
    let sales = 0;
    let promotionValue = 0;
    let billAmount = 0;
    invoiceList.map(element => (sales += Number(element.net_amount)));
    invoiceList.map(element => (billAmount += Number(element.amount)));
    invoiceList.map(element => (promotionValue += Number(element.promotion_discount)));
    const { billSummary } = this.state;
    billSummary.invoiceGrossValue = Number(sales.toFixed(2));
    billSummary.amount = sales;
    billSummary.promotionDiscountValue = promotionValue;
    billSummary.billAmount = billAmount;
    this.setState({ billSummary }, () => {
      this.setServiceInvoiceSummary();
    });
    // update the sales Invoice Summary
    this.setServiceInvoiceSummary();
  };

  // set the sales invoice summary
  setServiceInvoiceSummary = () => {
    // check the cash discount parameters
    const { billSummary, invoiceList } = this.state;
    const cashDiscountValue = getDiscountedValue(
      billSummary.invoiceGrossValue,
      billSummary.cashDiscountParam,
      billSummary.cashDiscount,
    );
    billSummary.cashDiscountValue = cashDiscountValue;

    const tradeDiscountAmountRef =
      billSummary.tradeDiscountParam === 'per'
        ? billSummary.invoiceGrossValue - billSummary.cashDiscountValue
        : billSummary.invoiceGrossValue;
    const tradeDiscountValue = getDiscountedValue(
      tradeDiscountAmountRef,
      billSummary.tradeDiscountParam,
      billSummary.tradeDiscount,
    );
    billSummary.tradeDiscountValue = tradeDiscountValue;

    const updatedInvoiceList = updateDiscountValueOfInvoiceList(invoiceList, cashDiscountValue, tradeDiscountValue);

    // to handle discountOption value selection changes
    if (cashDiscountValue === 0 && tradeDiscountValue === 0 && billSummary.amount !== billSummary.invoiceGrossValue) {
      billSummary.amount = billSummary.invoiceGrossValue;
    }

    let invoiceWithoutVat = Number(billSummary.invoiceGrossValue - (cashDiscountValue || 0) - (tradeDiscountValue || 0));
    billSummary.taxExemptedAmount = updatedInvoiceList.reduce((acc, item) => acc + item.tax_exempted_amount, 0);
    billSummary.actualTaxableAmount = invoiceWithoutVat - (billSummary.taxExemptedAmount || 0);
    // to handle negative amount and vat
    if (invoiceWithoutVat < 0) {
      invoiceWithoutVat = billSummary.invoiceGrossValue;
      billSummary.cashDiscountValue = 0;
      billSummary.cashDiscount = 0;
      billSummary.tradeDiscountValue = 0;
      billSummary.tradeDiscount = 0;
      billSummary.amount = invoiceWithoutVat;
    }
    billSummary.vatAmount = updatedInvoiceList.reduce((acc, item) => acc + item.vat, 0);
    billSummary.invoiceNetValue = Number((Number(invoiceWithoutVat) + Number(billSummary.vatAmount)).toFixed(2));
    billSummary.amount = Number(Number(invoiceWithoutVat).toFixed(2));

    // set the bill summary
    this.setState({ billSummary, invoiceList: updatedInvoiceList });
  };

  checkQuantity = abc => {
    const { stockQuantity } = this.state;
    if (abc > stockQuantity) {
      this.setState({
        showMessage: true,
        message: `Should not be greater than available quantity i.e ${stockQuantity}`,
      });
    }
  };

  getDiscountInput = createSku => {
    return fixedFloat(createSku.quantity * createSku.rlp || 0);
  };
  // handle change of create sku events
  onChange = (field, value, detail = {}) => {
    let { createSKU, stockQuantity, brandList, editRate } = this.state;

    createSKU[field] = value;
    /*if (field === 'brand') {
      createSKU.batch_id = '';
      createSKU.rate = 0;
      createSKU.promotion_discount = 0;
      createSKU.freeSku = false;
      createSKU.quantity = 0;
      createSKU.rlp = 0;
      createSKU.business_id = detail ? detail.businessId : '';
      createSKU.skuTitle = '';
      createSKU.sku_id = null;
      this.resetSKUDialog();
      this.setState(
        {
          batchList: [],
          keyValue: detail ? detail.businessId : '',
          stockQuantity: 0,
        },
        () => detail && this.getSKUListUnderBrand(value, detail.businessId),
      );
      if (value === '') {
        this.setState({ brandSKUList: [] });
      }
    }*/

    if (field === 'rate' && editRate) {
      createSKU.rate = value;
      createSKU.rlp = value;
    }

    if (field === 'sku_id') {
      createSKU.skuTitle = detail.title || '';
      createSKU.rate = detail.rlpWithExcise;
      createSKU.rlp = detail.rlpWithExcise;
      createSKU.freeSku = false;
      createSKU.quantity = 0;
      createSKU.business_id = detail.businessId;
      createSKU.vat_percent = detail.vatPercent || 0;
      createSKU = {
        ...(handleBatchSelect(createSKU, (detail.batchList.length > 0 && detail.batchList[0]) || {}) || createSKU),
      };
      this.setState(
        {
          batchList: detail.batchList || [],
        }
      );
    }

    if (field === 'quantity') {
      // this.checkQuantity(value);
      createSKU.promotion_discount = 0;
      createSKU.discount_input = 0;
      createSKU.selectedPromotionId = '';
      if (createSKU.freeSku) {
        createSKU.discount_input = this.getDiscountInput(createSKU);
      }
      // this.getApplicableSkusPromotions(createSKU.brand, createSKU.sku_id, createSKU.business_id, value);
    }

    if (field === 'discount_input') {
      // update discount number accordingly;
      if (createSKU.discount_label === 'rs') {
        createSKU.discount_input = Number(value.toFixed(2));
      }
      createSKU.selectedPromotionId = '';
    }
    if (field === 'freeSku') {
      createSKU.discount_input = this.getDiscountInput(createSKU);
      createSKU.discount_label = 'rs';
      if (!value) {
        createSKU.rate = createSKU.rlp;
        createSKU.discount_input = 0;
      }
    }

    if (field === 'promotion') {
      createSKU.selectedPromotionId = detail ? detail.id : null;
      createSKU.discount_label = detail
        ? detail.promotionDisbursement[0].disbursement_type === 'PERCENTAGE'
          ? 'per'
          : 'rs'
        : 'per';
      createSKU.discount_input = detail ? detail.promotionDisbursement[0].value : null;
      createSKU.promotion_discount_id = detail ? detail.id : 0;
    }
    // update the amount with rate and amount.
    createSKU.amount = Number(Number(createSKU.quantity * createSKU.rate).toFixed(2));
    const discount =
      createSKU.discount_label === 'rs'
        ? Number(createSKU.discount_input)
        : Number(createSKU.discount_input * createSKU.amount * 0.01).toFixed(2);

    createSKU.promotion_discount = discount;

    createSKU.net_amount = createSKU.freeSku ? 0 : Number(Number(createSKU.amount - discount).toFixed(2)) || 0;
    createSKU.vat = Number(Number((createSKU.vat_percent / 100) * createSKU.net_amount).toFixed(2)) || 0;
    // create SKU
    this.setState({ createSKU });
  };

  getApplicableSkusPromotions = (brand_id, sku_id, bu_id, quantity) => {
    promotionApi.getApplicablePromotions({ brand_id, sku_id, bu_id }).then(response => {
      const { data } = response;
      const quantityPromotions = data.filter(el => el.promotionCriteria[0].condition === 'QUANTITY');
      const amountPromotion = data.filter(el => el.promotionCriteria[0].condition === 'AMOUNT');
      const currentQuantityPromotion = quantityPromotions.filter(
        el => quantity >= Number(el.promotionCriteria[0].value),
      );
      const totalPromotions = [...amountPromotion, ...currentQuantityPromotion];
      const totalPromotionFiltered = totalPromotions.filter(d => new Date(d.end_date) >= new Date());
      this.setState({ promotionList: totalPromotionFiltered });
    });
  };

  // on change of the bill summary & update bill summary details.
  onChangeBillSummary = (field, value) => {
    const { billSummary } = this.state;
    billSummary[field] = value;
    if (field === 'cashDiscountParam') {
      billSummary.cashDiscount = 0;
    }
    if (field === 'tradeDiscountParam') {
      billSummary.tradeDiscount = 0;
    }
    this.setState({ billSummary }, () => {
      this.setServiceInvoiceSummary();
    });
  };

  // update the invoice grossValue
  createServiceInvoice = () => {
    const { invoiceList, createSKU } = this.state;
    // calculate the price
    createSKU.price = createSKU.quantity * createSKU.rate - createSKU.discount;
    invoiceList.push(createSKU);
    this.setState({ invoiceList }, () => {
      this.handleModalClose();
      // handle invoice item update
      this.handleInvoiceItemUpdate();
    });
  };

  // entire promotionList for the sku.
  // the promotion criteria list to be handled
  // editServiceInvoice
  editServiceInvoice = (data, index) => {
    const { invoiceList, createSKU } = this.state;
    invoiceList[index] = createSKU;
    this.setState({ invoiceList }, () => {
      this.handleModalClose();
      // handle invoice
      this.handleInvoiceItemUpdate();
    });
  };

  // creation of the new invoice
  // close the modal resetting  all the value
  handleModalClose = () => {
    this.resetSKUDialog();
    this.setState({
      modalOpen: false,
      editModalOpen: false,
      deleteModalOpen: false,
      batchList: [],
      brandSKUList: [],
    });
  };

  // reset SKU Dialog
  resetSKUDialog = () => {
    const createSKU = {
      brand: '',
      business_id: '',
      sku: '',
      sku_id: 0,
      skuTitle: '',
      rate: 0,
      quantity: 0,
    
      batchTitle: '',
      amount: 0,
      promotion_discount_id: 0,
      promotion_discount: 0,
      discount_label: 'per',
      discount_input: 0,
      promotion_title: '',
      bill_discount: 0,
      trade_discount: 0,
      net_amount: 0,
      vat: 0,
      freeSku: false,
      rlp: 0,
      selectedPromotionId: '',
      vat_percent: VAT_PERCENTAGE,
      particulars:'',
    };
    this.setState({
      createSKU,
      formEmptyField: false,
    });
  };

  // delete the sales invoice
  deleteServiceInvoice = () => {
    const { invoiceList, indexInInvoiceList } = this.state;
    invoiceList.splice(indexInInvoiceList, 1);
    this.setState({ invoiceList }, () => {
      this.handleModalClose();
      this.handleInvoiceItemUpdate();
    });
  };
  validateForm = (formObject, config, flag) => {
    const data = Object.keys(formObject).some(k => {
      if (config.indexOf(k) > -1) {
        let value = formObject[k];
        if (!value) {
          this.setState({ [flag]: true });

          return true;
        }
      }
    });

    return !data;
  };

  // on edit icon click , pop up the dialog with pre filled parameters.
  handleEditIconClick = (data, index) => {
    this.populateBrandSKUList(data.brand, data.sku_id, data.business_id);

    const createSKU = {
      brand: data.brand,
      sku: data.sku,
      particulars:data?.particulars,
      skuTitle: data.skuTitle,
      business_id: data.business_id,
      sku_id: data.sku_id,
      rate: data.rate,
      rlp: data.rlp || data.rate,
      quantity: data.quantity,
     
      batchTitle: data.batchTitle,
      amount: data.amount,
      promotion_discount: data.promotion_discount,
      promotion_discount_id: data.promotion_discount_id,
      promotion_title: data.promotion_title,
      bill_discount: data.bill_discount,
      trade_discount: data.trade_discount,
      net_amount: data.net_amount,
      vat_percent: data.vat_percent,
      vat: data.vat,
      discount_label: data.discount_label,
      discount_input: data.discount_input,
      freeSku: data.freeSku || false,
      createSku: data.rlpWithExcise || data.rate,
      selectedPromotionId: data.selectedPromotionId,
    };

    this.setState({
      createSKU,
      editModalOpen: true,
      indexInInvoiceList: index,
    });
  };

  // handle delete icon click.
  handleDeleteIconClick = index => {
    this.setState({
      deleteModalOpen: true,
      indexInInvoiceList: index,
    });
  };

  // handle cancel button click
  handleCancelClick = () => {
    history.push(`/${SERVICE_INVOICE_BASE}`);
  };

  handleSaveClick = () => {
    const valid = this.handleInvoiceValidation();
    if (valid) {
      this.setServiceInvoice();
    }
  };

  handleInvoiceValidation = () => {
    const { customerDetails, invoiceList, cashStatus, pageValidateFieldArray, billSummary, idAgent } = this.state;
    let validationFields = pageValidateFieldArray;
    const checkForValidCashParty = LEDGERS.CASH.validInvoiceAmount >= billSummary.invoiceNetValue;

    /* todo: need to handle  displaying error message from common section */

    if (invoiceList.length < 1) {
      this.setState({
        showMessage: true,
        success: false,
        message: message.invoiceListEmptyError,
        directToPrintFlag: false,
      });

      return false;
    }

    if (!checkForValidCashParty) {
      // check for cash ledger only
      if (cashStatus && customerDetails.customerId === LEDGERS.CASH.ledger_id) {
        this.setState({
          showMessage: true,
          success: false,
          message: message.cashBillError,
          directToPrintFlag: false,
        });

        return false;
      }

      return this.validateForm(customerDetails, validationFields, 'pageEmptyField');
    }
    validationFields = cashStatus ? pageValidateFieldTypes.cash : pageValidateFieldTypes.customer;
    this.updatePageValidateFields(validationFields);

    return this.validateForm({ remarks: billSummary.remarks, ...customerDetails }, validationFields, 'pageEmptyField');
  };

  // on okay click for the modal
  handleModalOk = () => {
    const {
      createSKU: { business_id, sku_id, discount_input, brand, net_amount, quantity, rate, selectedPromotionId },
    } = this.state;

    const query = {
      bu_id: business_id,
      sku_id,
      discount: Number(discount_input),
      brand_id: brand,
      net_amount,
      quantity,
      rate,
    };

    if (selectedPromotionId) {
      promotionApi
        .validatePromotion({ id: selectedPromotionId, query })
        .then(response => {
          this.handleCreateSKUSubmit();
        })
        .catch(err => {
          this.setState({
            showMessage: true,
            message: err.message,
          });
        });
    } else {
      this.handleCreateSKUSubmit();
    }
  };

  handleCreateSKUSubmit = () => {
    const { modalOpen, editModalOpen, createSKU, formValidateFieldArray, indexInInvoiceList } = this.state;
    if (modalOpen || editModalOpen) {
      const valid = this.validateForm(createSKU, formValidateFieldArray, 'formEmptyField');

      if (valid) {
        if (modalOpen) {
          this.createServiceInvoice();
        } else {
          this.editServiceInvoice(createSKU, indexInInvoiceList);
        }
      }
    } else {
      this.deleteServiceInvoice();
    }
  };

  handleCheckBoxClick = (fieldName, flag) => {
    this.setState({ [fieldName]: flag });
    const { billSummary } = this.state;
    // if the flag is set off reset value to 0 and disable
    if (fieldName === 'cashDiscountCheckBoxFlag') {
      billSummary.cashDiscountValue = 0;
      billSummary.cashDiscount = 0;
      billSummary.cashDiscountParam = discountOptions[0].value;
    } else if (fieldName === 'tradeDiscountCheckBoxFlag') {
      billSummary.tradeDiscountValue = 0;
      billSummary.tradeDiscount = 0;
      billSummary.tradeDiscountParam = discountOptions[0].value;
    }
    this.setState({ billSummary }, () => this.setServiceInvoiceSummary());
  };

  handleCashCheckClick = flag => {
    const { pageValidateFieldArray, customerDetails, billSummary } = this.state;
    const validationType = flag ? pageValidateFieldTypes.cash : pageValidateFieldArray;
    customerDetails.customerId = flag ? LEDGERS.CASH.ledger_id : '';
    customerDetails.address = '';
    customerDetails.panNo = '';
    customerDetails.phoneNumber = '';
    customerDetails.id = '';
    customerDetails.name = '';
    billSummary.billName = '';
    this.setState(
      {
        cashStatus: flag,
        customerDetails,
        billSummary,
      },
      () => this.updatePageValidateFields(validationType),
    );
  };

  updatePageValidateFields = list => {
    const { pageValidateFieldArray } = this.state;
    if (!compareList(list, pageValidateFieldArray)) this.setState({ pageValidateFieldArray: list });
  };

  // get the customer list for the selection.
  getCustomerList = () => {
    ledgerApi.getCustomerList().then(response => {
      if (checkIfApiCallSuccess(response)) {
        const customerList = response.data.list;
        this.setState({ customerList });
      }
    });
  };

  // get the sku list under the brand
  getSKUListUnderBrand = (brandId) => {
    const {businessId} =this.state;
    this.setState({ skuList: [] });
    catalogsApi
      .getSkuUnderBrand({
        business_id: businessId,
        brand_id: brandId,
      })
      .then(response => {
        if (checkIfApiCallSuccess(response)) {
          const list = response.data.list;
          this.setState({ skuList: list, brandSKUList: list });
        }
      });
  };

  // get sku list
  getSkuList =  () => {
    const { businessId } = this.state;
    catalogsApi.getSkuList({ business_id: businessId,  }).then((response) => {
      if (checkIfApiCallSuccess(response)) {
        this.setState({ skuList: response.data.list });
      }
    });
  };

  getBrandSkuList = async inputValue => {
    const { brandSKUList } = this.state;
    const filteredSKUList = brandSKUList.filter(list => list.title.toLowerCase().includes(inputValue.toLowerCase()));
    this.setState({ skuList: filteredSKUList });
    return filteredSKUList;
  };

  populateBrandSKUList = (brandId, skuId) => {
    const {businessId} =this.state;
    catalogsApi
      .getSkuUnderBrand({
        business_id: businessId,
        brand_id: brandId,
      })
      .then(response => {
        if (checkIfApiCallSuccess(response)) {
          const skuList = response.data.list;
          const selectedSKU = skuList.find(sku => sku.businessSkuId === skuId);
          const batchList = selectedSKU.batchList ? selectedSKU.batchList : [];
          this.setState({ skuList: response.data.list, batchList });
        }
      });
  };

  // get BU list
  getBUList = () => {
    buApi.getList().then(response => {
      if (checkIfApiCallSuccess(response)) {
        this.setState({ buList: response.data.list });
      }
    });
  };

  getAgentList = () => {
    salesInvoiceApi.getAgentList().then(response => {
      if (checkIfApiCallSuccess(response)) {
        const agentList = response.data.list;
        this.setState({ agentList });
      }
    });
  };

  // handle the customer drop down change
  onCustomerDropDownChange = (field, id, customer) => {
    const { billSummary } = this.state;
    const customerDetails = {
      id: customer.idLedger || '',
      customerId: customer.customerId || '',
      name: customer.title || '',
      address: customer.address || '',
      panNo: customer.panNo || '',
      phoneNumber: customer.phoneNumber || '',
    };
    billSummary.billName = customer.title;
    this.setState({ customerDetails, billSummary });
  };

  onAgentDropDownChange = (field, id, agent) => {
    this.setState({ idAgent: agent.idAgent });
  };

  directToPrint = () => {
    const { showMessage, success, printDetails } = this.state;
    if (!showMessage && success) {
      const modifiedId = voucherEncoder(printDetails.invoiceNumber);
      this.setState({ startPrint: true });
      history.push(`/${SERVICE_INVOICE_DETAILS}/${modifiedId}`, {
        details: printDetails,
        firstCopy: true,
      });
    }
  };

  getInvoiceList = () => clone(this.state.invoiceList);

  // set the sales invoice calling to the server. //also set custome ref id
  setServiceInvoice = () => {
    const { idAgent, billSummary, customerDetails, businessId, printDetails, cashStatus } = this.state;
    const { user } = this.props;
    const invoiceList = this.getInvoiceList();
    const filteredInvoiceList = invoiceList.map(skuDetails => {
      delete skuDetails.sku;
      delete skuDetails.brand;
      delete skuDetails.price;
      delete skuDetails.promotion_title;
      skuDetails.customer_ref_id = customerDetails.customerId;
      delete skuDetails.batch_id

      return skuDetails;
    });
    const objectDetail = {
      business_id: businessId,
      customer_ref_id: customerDetails.customerId,
      entered_by: user.idUsers,
      amount: billSummary.billAmount,
      taxable_amount: billSummary.amount,
      tax_exempted_amount: billSummary.taxExemptedAmount || 0,
      bill_discount: billSummary.cashDiscountValue,
      trade_discount: billSummary.tradeDiscountValue,
      promotion_discount: billSummary.promotionDiscountValue,
      customer_name: billSummary.billName,
      vat: billSummary.vatAmount,
      remarks: billSummary.remarks,
      net_amount: billSummary.invoiceNetValue,
      skuDetail: filteredInvoiceList,
      customer_type: cashStatus ? customerType.CASH : customerType.CUSTOMER,
      agentId: idAgent,
      payment_mode: cashStatus ? customerType.CASH : customerType.CUSTOMER,
      sender_ledger_id:customerDetails?.customerId,
    };

    this.setState({ loading: true, saveDisable: true });
    salesInvoiceApi
      .create(objectDetail)
      .then(response => {
        this.setState({ loading: false });
        // todo direct to print page.
        if (response.success) {
          printDetails.invoiceNumber = response.data.detail.invoice_number;
          this.salesId = response.data.detail.invoice_number;
          this.firstCopy = true;

          this.setState({
            showMessage: true,
            success: true,
            message: message.success,
            printDetails,
            directToPrintFlag: true,
            saveDisable: true,
          });
        }
      })
      .catch(error => {
        {
          let errormessage = '';
          try {
            errormessage = this.PrepareErrorMessage(error);
          } catch {
            errormessage = error.message;
          }
          this.setState({
            loading: false,
            showMessage: true,
            success: false,
            message: errormessage,
            directToPrintFlag: false,
            saveDisable: false,
          });
        }
      });
  };

  PrepareErrorMessage(errorData) {
    const data = errorData.response.data.data;
    let skus = '';
    for (let i = 0; i < data.length; i++) {
      skus = skus + data[i].skuTitle + ',';
    }
    skus = skus.replace(/.$/, '.');
    return `The following SKUs do not have enough stock to process invoice.  ${skus}`;
  }

  handlePostPrint = () => {
    this.setState({ startPrint: false }, () => history.push(`/${SERVICE_INVOICE_BASE}`));
  };

  constructor(props) {
    super(props);
    const businessId = getBusinessId();
    this.state = {
      success: true,
      loading: false,
      modalOpen: false,
      startPrint: false,
      cashStatus: false,
      showMessage: false,
      saveDisable: false,
      editModalOpen: false,
      formEmptyField: false,
      pageEmptyField: false,
      deleteModalOpen: false,
      directToPrintFlag: false,
      stockQuantity: 0,
      cashDiscountCheckBoxFlag: false,
      tradeDiscountCheckBoxFlag: false,
      businessUnitId: null,
      message: message.success,
      indexInInvoiceList: 0,
      promotionValidationFailed: false,
      printDetails: {
        printedBy: '',
        invoiceNumber: '',
        transaction: 'SALES',
      },
      createSKU: {
        brand: '',
        sku: '',
        sku_id: 0,
        skuTitle: '',
        batchTitle: '',
        rate: 0,
        quantity: 0,
       
        amount: 0,
        promotion_title: '',
        promotion_discount: 0,
        bill_discount: 0,
        trade_discount: 0,
        taxable_amount: 0,
        tax_exempted_amount: 0,
        net_amount: 0,
        discount_label: discountOptions[0].value,
        discount_input: 0,
        vat: 0,
        promotion_discount_id: 0,
        freeSku: false,
        rlp: 0,
        selectedPromotionId: '',
        vat_percent: VAT_PERCENTAGE,
      },
      customerDetails: {
        id: '',
        customerId: '',
        name: '',
        address: '',
        phoneNumber: '',
        panNo: '',
      },
      billSummary: {
        invoiceGrossValue: 0,
        cashDiscountParam: discountOptions[0].value,
        cashDiscount: 0,
        cashDiscountValue: 0,
        tradeDiscountParam: discountOptions[0].value,
        tradeDiscount: 0,
        tradeDiscountValue: 0,
        promotionDiscountValue: 0,
        vatAmount: 0,
        invoiceNetValue: 0,
        amount: 0,
        billAmount: 0,
        remarks: '',
        billName: '',
        actualTaxableAmount: 0,
        taxExemptedAmount: 0,
      },
      date: {
        start: filterUtil.getStartOfCurrentMonth(),
        end: filterUtil.getCurrentDay(),
      },
      formValidateFieldArray: ['sku_id', 'quantity'],
      pageValidateFieldArray: pageValidateFieldTypes.customer,
      invoiceList: [],
      customerList: [],
      brandList: [],
      skuList: [],
      batchList: [],
      buList: [],
      promotionList: [],
      promotionByCriteria: [],
      agentList: [],
      idAgent: 0,
      keyValue: '',
      editRate: false,
      editRatePermission: false,
      brandSKUList: [],
      businessId,
    };
    this.salesId = '';
    this.firstCopy = false;
  }

  /** adjust table width and height according to screen * */
  componentDidMount() {
    this.getBUList();
    this.setRlpEditStatus();
    this.getCustomerList();
    this.getAgentList();
  }

  setRlpEditStatus() {
    const settings = localStorage.getItem(JWT.LOCAL_STORAGE.SETTINGS.NAME);
    if (settings) {
      let parsedSettings = JSON.parse(settings);
      if (parsedSettings) {
        this.setState({ editRate: !!parsedSettings.editRate });
      }
    }
    this.setState({ editRatePermission: !!this.props.permission.includes('EditRate') });
  }

  handleBUClick = id => {
    this.setState({ businessUnitId: id ,businessId:id}, () => {
      this.getSkuList();
    });
  };

  render() {
    const {
      buList,
      skuList,
      brandSKUList,
      loading,
      createSKU,
      brandList,
      batchList,
      agentList,
      modalOpen,
      cashStatus,
      idAgent,
      showMessage,
      invoiceList,
      saveDisable,
      editModalOpen,
      formEmptyField,
      deleteModalOpen,
      stockQuantity,
      cashDiscountCheckBoxFlag,
      keyValue,
      editRate,
      promotionList,
      promotionValidationFailed,
      businessUnitId,
      customerList,
      businessId,
    } = this.state;
    return (
      <ServiceInvoiceStyled>
        {loading && (
          <div className="linear-progress-wrapper temp-progress-wrapper">
            <LinearProgress accent indeterminate />
          </div>
        )}
        {!this.state.startPrint && (
          <div className={`sales-invoice-create pad-b-24${loading ? 'clickable-false' : ''}`}>
            <div className="message-snackbar">
              {
                <Snackbar
                  multiline
                  className={this.state.success ? 'success-message' : ''}
                  timeout={this.state.success ? 3000 : 10000}
                  onTimeout={() => {
                    this.setState({ showMessage: false }, () => {
                      if (this.state.directToPrintFlag) {
                        this.directToPrint();
                      }
                    });
                  }}
                  open={showMessage}
                >
                  {this.state.message}
                </Snackbar>
              }
            </div>
            <div className="card-header-bar clearfix" ref="tableReference">
              <div className="header-left">
                <h2>New Service Invoice</h2>
              </div>
              <div className="header-right">{this.state.date.end}</div>
            </div>
            <div className="card-body">
              <div className="radio-list-wrapper clearfix">
              <div className="float-left">
                  {buList.length && (
                    <RadioButtonList data={buList} handleBuClick={this.handleBUClick} disableRosiaBu />
                  )}
                </div>
                <div className="float-right cash-checkbox">
                  <Checkbox
                    checked={cashStatus}
                    onChange={({ target: { checked } }) => {
                      this.handleCashCheckClick(checked);
                    }}
                  />
                  <label>Cash</label>
                </div>
              </div>
              <div className={businessUnitId !== null ? '' : 'block-overlay-wrapper'}>
              <div className={businessUnitId !== null ? '' : 'block-overlay'}>
                <div className="three-input-wrapper">
                  <Grid>
                    <Cell col={3} className="input-select">
                      <label>Customer Name</label>
                      <BillingSelect
                        name="form-field-name"
                        param="name"
                        clearable={false}
                        isSearchable
                        value={this.state.customerDetails.name}
                        valueKey="title"
                        getOptionLabel={({ title, address, panNo }) => (
                          <>
                            <div>{title}</div>
                            <span>{`PAN: ${panNo} | Address: ${address}`}</span>
                          </>
                        )}
                        getOptionValue={({ title }) => title}
                        options={this.state.customerList}
                        handleChange={this.onCustomerDropDownChange}
                        required
                        emptyField={this.state.pageEmptyField}
                        multipleParam
                      />
                    </Cell>
                    <Cell col={3}>
                      <BillingTextField
                        value={this.state.customerDetails.address}
                        floatingLabel="Address"
                        required={false}
                        className="billing-required no-pointer-events right-side-gap"
                        emptyField={this.state.pageEmptyField}
                      />
                    </Cell>
                    <Cell col={3}>
                      <BillingTextField
                        value={this.state.customerDetails.panNo}
                        floatingLabel="PAN Number"
                        type="number"
                        rule="isInt"
                        required
                        className="billing-required no-pointer-events right-side-gap"
                      />
                    </Cell>
                    <Cell col={3} className="input-field">
                      <BillingTextField
                        value={this.state.billSummary.remarks}
                        param="remarks"
                        floatingLabel="Remarks"
                        /* required */
                        className="billing-required"
                        handleChange={(param, value) => {
                          const { billSummary } = this.state;
                          billSummary[param] = value;
                          this.setState({ billSummary });
                        }}
                        /* emptyField={this.state.pageEmptyField} */
                      />
                    </Cell>
                  </Grid>
                </div>
                <div className="table-wrapper">
                  <div ref="fixedTableBody" className="fixed-table-wrapper">
                    <table>
                      <TableHeader
                        headerDetails={createServiceInvoiceConfig.headerDetails}
                        filterHeaderLabel={false}
                        handleSorting={this.handleTableSorting}
                      />
                      {invoiceList.map((data, key) => (
                        <tbody>
                          <CreateServiceInvoiceTableBody
                            data={data}
                            index={key}
                            deleteServiceInvoice={this.deleteServiceInvoice}
                            handleEditIconClick={this.handleEditIconClick}
                            handleDeleteIconClick={this.handleDeleteIconClick}
                          />
                        </tbody>
                      ))}
                    </table>
                  </div>

                  {/* Fab Icon */}
                  <div className="mini-fab-button">
                    <Fab mini onClick={() => this.setState({ modalOpen: true })}>
                      <Icon name="add" />
                    </Fab>
                  </div>
                </div>
                {/* Sales invoice table summary goes over here. */}
                <DiscountBarStyled>
                  <div className="total-section-wrapper">
                    <Grid>
                      <Cell col={8} />
                      <Cell col={3} className="right-align active-opacity-text">
                        {' '}
                        Sub Total
                      </Cell>
                      <Cell col={1} className="right-align">
                        {' '}
                        {this.state.billSummary.invoiceGrossValue}
                      </Cell>
                    </Grid>

                    <Grid>
                      <Cell col={3}> </Cell>
                      <Cell col={8} className="sub-total-wrap right-align">
                        <FormField id="cashDiscountCheckbox">
                          <Checkbox
                            checked={this.state.cashDiscountCheckBoxFlag}
                            onChange={({ target: { checked } }) => {
                              this.handleCheckBoxClick('cashDiscountCheckBoxFlag', checked);
                            }}
                          />
                          <label>Discount</label>
                        </FormField>

                        <span
                          className={cashDiscountCheckBoxFlag ? 'sub-total-wrap' : 'sub-total-wrap no-pointer-events'}
                        >
                          <BillingSelect
                            className="display-inline-table"
                            name="form-field-name"
                            clearable={false}
                            value={discountOptions.filter(
                              option => option.value === this.state.billSummary.cashDiscountParam,
                            )}
                            options={discountOptions}
                            onChange={e => this.onChangeBillSummary('cashDiscountParam', e.value)}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                          />
                          <span className="default-left-margin-9">
                            <BillingTextField
                              value={this.state.billSummary.cashDiscount}
                              handleChange={this.onChangeBillSummary}
                              type="number"
                              param="cashDiscount"
                              max={
                                this.state.billSummary.cashDiscountParam === 'rs'
                                  ? this.state.billSummary.invoiceGrossValue
                                  : '99'
                              }
                            />
                          </span>
                        </span>
                      </Cell>
                      <Cell col={1} className="right-align default-top-padding-12">
                        {fixedFloatAndCommas(this.state.billSummary.cashDiscountValue)}
                      </Cell>
                    </Grid>

                    <Grid className="padding-top-24">
                      <Cell col={8} />
                      <Cell col={3} className="right-align active-opacity-text">
                        {' '}
                        Taxable Amount
                      </Cell>
                      <Cell col={1} className="right-align">
                        {' '}
                        {fixedFloatAndCommas(this.state.billSummary.actualTaxableAmount) || 0}
                      </Cell>
                    </Grid>
                    <Grid className="default-margin-top-12">
                      <Cell col={8} />
                      <Cell col={3} className="right-align active-opacity-text">
                        VAT
                      </Cell>
                      <Cell col={1} className="right-align">
                        {' '}
                        {fixedFloatAndCommas(this.state.billSummary.vatAmount)}
                      </Cell>
                    </Grid>
                    <div className="hr" />
                    <Grid>
                      <Cell col={8} />
                      <Cell col={3} className="right-align active-opacity-text">
                        Total
                      </Cell>
                      <Cell col={1} className="right-align font-bold">
                        {fixedFloatAndCommas(this.state.billSummary.invoiceNetValue)}
                      </Cell>
                    </Grid>
                  </div>
                </DiscountBarStyled>
              </div>
              </div>

              {/* Dialog View */}
              <CreateInvoiceDialog
                handleModalClose={this.handleModalClose}
                modalOpen={modalOpen}
                editModalOpen={editModalOpen}
                deleteModalOpen={deleteModalOpen}
                createSKU={createSKU}
                handleInputChange={this.onChange}
                loadOptions={createSKU.brand === '' ? this.getSkuList : this.getBrandSkuList}
                onModalSubmit={this.handleModalOk}
                skuList={skuList}
                brandSKUList={brandSKUList}
                brandList={brandList}
                batchList={batchList}
                formEmptyField={formEmptyField}
                stockQuantity={stockQuantity}
                keyValue={keyValue}
                editRate={editRate}
                editRatePermission={this.state.editRatePermission}
                promotionList={promotionList}
                promotionValidationFailed={promotionValidationFailed}
              />
            </div>
            <div className="newinvoice-btn-wrapper">
              <Grid>
                <Cell col={8} />
                <Cell col={4} className="right-align">
                  <Button
                    accent
                    className="cancel-btn modal-btn"
                    onClick={() => {
                      this.handleCancelClick();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    accent
                    className={saveDisable ? 'save-btn modal-btn btn-disabled' : 'save-btn modal-btn'}
                    disabled={saveDisable}
                    onClick={() => {
                      this.handleSaveClick();
                    }}
                  >
                    Save
                  </Button>
                </Cell>
              </Grid>
            </div>
          </div>
        )}
        {this.state.startPrint && (
          <InvoiceDetails id={this.salesId} firstCopy={this.firstCopy} postPrintHandler={this.handlePostPrint} />
        )}
      </ServiceInvoiceStyled>
    );
  }
}

CreateInvoice.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = state => ({
  user: state.billing.user || null,
  company: state.billing.company || null,
  bu_id: state.billing.bu_id || null,
  permission: state.billing.permission || [],
});

const CreateServiceInvoice = connect(mapStateToProps)(CreateInvoice);

export default CreateServiceInvoice;
